import styled from "styled-components"


export const SideMenuListContainer = styled.div`
  width: 100%;
`

export const SideMenuListItem = styled.div`
    border-bottom: 1px solid #e7e7eb;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: var(--SideMenuListItemFont-family);
    color: #4d5565;
    padding: 1.25rem;
    cursor: pointer;
    background-color: ${props => props.selected ? '#e7edf9' : '#FFFFFF'};
`
export const SideMenuListSeparator = styled.div``
